import { GatewayFwUpdateInfo } from './gateway-fw-update-info.model';

export class AccountFirmwareUpdateInfo
{
    constructor(json: any = null)
    {
        if (json)
        {
            Object.assign(this, json);

            this.Gateways = json.Gateways.map(g => new GatewayFwUpdateInfo(g));
        }
    }

    DevicesPendingUpdateCount = 0;
    Gateways: GatewayFwUpdateInfo[];
}
